import {makeReactContext} from 'lib/makeReactContext';
import {FlowchartEdge} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';

export interface EdgesContextValue {
  edges: Array<FlowchartEdge>;
  onEdgeRemove: (edgeId: string) => void;
}

/** Context to provide the full set of edges in the flowchart */
export const EdgesContext = makeReactContext<EdgesContextValue>(
  () => ({edges: [], onEdgeRemove: () => {}}),
  'EdgesContext'
);
